import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_request_partner_nav = _resolveComponent("request-partner-nav")!
  const _component_white_box_main = _resolveComponent("white-box-main")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    "header-left": _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "Rejected", -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(_component_white_box_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_request_partner_nav),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "send-to-partner-box" }, [
            _createElementVNode("div", { class: "box-title" }, "Rejected requests"),
            _createTextVNode(" List of items @TODO ")
          ], -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}